import PresentationSelect from "./PresentationSelect.vue";
export { PresentationSelect };
